import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, Button } from 'semantic-ui-react';
import Modal from '@/components/Modal';
import * as actions from '@/store/actions';

import useTranslate from '@/hooks/useTranslate';

interface Props {
    webhookId?: string;
    onCancel: (e: React.MouseEvent) => void;
}

const TestWebhookModal: React.FC<Props> = (props) => {
    const {  onCancel, webhookId } = props;

    const dispatch = useDispatch();
    const { translate } = useTranslate();

    const isLoading = useSelector((state: any) => state.testWebhook.isLoading);

    const handleTestWebhook = useCallback(
        (e) => {
            dispatch(actions.TEST_WEBHOOK.request({
                Id: webhookId,
            }));
        },
        [dispatch, webhookId]
    );

    return (
        <Modal open size="tiny" style={{ textAlign: 'center' }} onClose={onCancel}>
            <Modal.Header>
                <Header
                    size="medium"
                    content={translate('webhooks.test.messageBox')}
                    icon="paper plane"
                />
            </Modal.Header>

            <Modal.Actions style={{ justifyContent: 'space-between' }}>
                <Button
                    basic
                    content={translate('form.cancel')}
                    onClick={onCancel}
                />
                <Button
                    positive
                    content={translate('webhooks.test.text')}
                    onClick={handleTestWebhook}
                    loading={isLoading}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default TestWebhookModal;
